import React from 'react';

const SendMassMailsLogo = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1"
      y="8.88086"
      width="19"
      height="13"
      rx="2"
      transform="rotate(-27.8653 1 8.88086)"
      fill="#03045E"
    />
    <path
      d="M22.471 8.84086L4.42945 12.158L2.7682 7.94608L15.1449 1.40255C16.6096 0.628149 18.4248 1.18778 19.1992 2.65252L22.471 8.84086Z"
      fill="url(#paint0_linear_7572_5400)"
    />
    <path
      d="M1.93479 10.649C1.41852 9.67246 1.7916 8.46234 2.7681 7.94607L16.0288 0.935147C17.0053 0.418878 18.2154 0.791962 18.7317 1.76845L18.9814 2.24074C19.3892 3.01212 19.2499 3.95887 18.6371 4.58006L13.1138 10.1793C12.8251 10.4719 12.4533 10.6685 12.0489 10.7423L4.31155 12.154C3.45316 12.3106 2.59231 11.8926 2.18448 11.1212L1.93479 10.649Z"
      fill="#0077B6"
    />
    <path
      d="M1.93479 10.649C1.41852 9.67246 1.7916 8.46234 2.7681 7.94607L16.0288 0.935147C17.0053 0.418878 18.2154 0.791962 18.7317 1.76845L18.9814 2.24074C19.3892 3.01212 19.2499 3.95887 18.6371 4.58006L13.1138 10.1793C12.8251 10.4719 12.4533 10.6685 12.0489 10.7423L4.31155 12.154C3.45316 12.3106 2.59231 11.8926 2.18448 11.1212L1.93479 10.649Z"
      fill="url(#paint1_linear_7572_5400)"
    />
    <rect
      x="10.0054"
      y="11.8848"
      width="19"
      height="13"
      rx="2"
      transform="rotate(-11.7853 10.0054 11.8848)"
      fill="#023E8A"
    />
    <path
      d="M30.6472 17.7935L12.3927 15.9837L11.9631 11.4764L25.668 8.61701C27.2899 8.27861 28.8791 9.31911 29.2175 10.941L30.6472 17.7935Z"
      fill="url(#paint2_linear_7572_5400)"
    />
    <path
      d="M10.4139 13.8427C10.1883 12.7614 10.8819 11.7019 11.9632 11.4763L26.647 8.41267C27.7283 8.18707 28.7877 8.88074 29.0133 9.96202L29.1225 10.485C29.3007 11.3392 28.9046 12.2103 28.1437 12.6374L21.2855 16.4878C20.9271 16.689 20.5154 16.7749 20.1064 16.7338L12.2808 15.9471C11.4126 15.8598 10.7012 15.2198 10.523 14.3656L10.4139 13.8427Z"
      fill="#00B4D8"
    />
    <path
      d="M10.4139 13.8427C10.1883 12.7614 10.8819 11.7019 11.9632 11.4763L26.647 8.41267C27.7283 8.18707 28.7877 8.88074 29.0133 9.96202L29.1225 10.485C29.3007 11.3392 28.9046 12.2103 28.1437 12.6374L21.2855 16.4878C20.9271 16.689 20.5154 16.7749 20.1064 16.7338L12.2808 15.9471C11.4126 15.8598 10.7012 15.2198 10.523 14.3656L10.4139 13.8427Z"
      fill="url(#paint3_linear_7572_5400)"
    />
    <rect
      x="3.80078"
      y="15"
      width="19"
      height="13"
      rx="2"
      transform="rotate(7.9634 3.80078 15)"
      fill="#0077B6"
    />
    <path
      d="M1.99951 26.5002L12.4995 23.0002L3.49951 18.0002L1.99951 26.5002Z"
      fill="url(#paint4_linear_7572_5400)"
    />
    <path
      d="M21.232 27.5359L4.6627 19.6644L5.78131 15.2771L19.6463 17.2167C21.2872 17.4462 22.4313 18.9625 22.2018 20.6034L21.232 27.5359Z"
      fill="url(#paint5_linear_7572_5400)"
    />
    <path
      d="M3.5237 16.9807C3.67673 15.8868 4.68758 15.1241 5.78149 15.2771L20.6368 17.3552C21.7308 17.5082 22.4935 18.5191 22.3405 19.613L22.2665 20.1421C22.1456 21.0062 21.4784 21.6922 20.618 21.8372L12.8622 23.1437C12.4569 23.212 12.0403 23.1537 11.6693 22.9768L4.56973 19.5922C3.7821 19.2167 3.3288 18.3739 3.44969 17.5098L3.5237 16.9807Z"
      fill="#48CAE4"
    />
    <path
      d="M3.5237 16.9807C3.67673 15.8868 4.68758 15.1241 5.78149 15.2771L20.6368 17.3552C21.7308 17.5082 22.4935 18.5191 22.3405 19.613L22.2665 20.1421C22.1456 21.0062 21.4784 21.6922 20.618 21.8372L12.8622 23.1437C12.4569 23.212 12.0403 23.1537 11.6693 22.9768L4.56973 19.5922C3.7821 19.2167 3.3288 18.3739 3.44969 17.5098L3.5237 16.9807Z"
      fill="url(#paint6_linear_7572_5400)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7572_5400"
        x1="10.0616"
        y1="4.09007"
        x2="16.9076"
        y2="10.0855"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7572_5400"
        x1="2.58514"
        y1="9.73954"
        x2="12.6702"
        y2="10.6289"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#82E5F8" />
        <stop offset="1" stopColor="#48CAE4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7572_5400"
        x1="20.0392"
        y1="9.79141"
        x2="24.9567"
        y2="17.4484"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_7572_5400"
        x1="11.2907"
        y1="13.149"
        x2="20.7348"
        y2="16.7969"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#82E5F8" />
        <stop offset="1" stopColor="#48CAE4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_7572_5400"
        x1="8.99951"
        y1="20.5002"
        x2="6.99951"
        y2="26.5002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#54C2FC" />
        <stop offset="1" stopColor="#026193" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_7572_5400"
        x1="13.9518"
        y1="16.4201"
        x2="15.9928"
        y2="25.2883"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_7572_5400"
        x1="4.58333"
        y1="16.6241"
        x2="12.2394"
        y2="23.2486"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0EA4C2" />
        <stop offset="1" stopColor="#48CAE4" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default SendMassMailsLogo;
